/**
 * Creates a URL for a page
 * @param {string} pageName - Name of the page (e.g., "Home", "Articles?slug=article-slug")
 * @returns {string} - The page URL
 */
export function createPageUrl(pageName) {
  // Handle query parameters
  if (pageName.includes('?')) {
    const [name, query] = pageName.split('?');
    return `/${name.toLowerCase()}?${query}`;
  }
  // Handle root page
  if (pageName.toLowerCase() === 'home') {
    return '/';
  }
  return `/${pageName.toLowerCase()}`;
}

/**
 * Parses query parameters from URL
 * @param {string} search - URL search string (e.g., "?slug=article-slug")
 * @returns {object} - Object with query parameters
 */
export function parseQueryParams(search) {
  const params = new URLSearchParams(search);
  const result = {};
  for (const [key, value] of params.entries()) {
    result[key] = value;
  }
  return result;
}

